import React from "react";
import { Loading, ImageLoad, Wrapper } from "@/components";
import { i18n, priceFormat, loadHTMLImage } from "@/utils";
import classnames from "classnames";
import styles from "./style.less";
import Icon from "../icon";
import NumLoading from "../loading";
import GiftDrawer from "../giftdrawer";
import { Shop } from "@/sunzi";
import { Type } from "./spotify-code-film";
import { VipIncrement } from "@/increment/increment";
interface PreviewProps {
  renderContent: React.ReactNode;
  onClose(): void;
  onConfirm(vipIncrement?: VipIncrement, giftBox?: Type): void;
  onCustom(): void;
  handleCloseCart(): void;
  filmStyle?: string;
  selectPage: boolean;
  /**加价 */
  addPrice: string;
  /**钱符号 */
  currencySymbol?: string;
  showSpotify: boolean;
  /**照片上传失败 */
  uploadError: boolean;
  /**重置动画 */
  reStart: boolean;
  /** 上传进度 */
  percent: number;
  /** 店铺 */
  shop?: Shop;
  /** 礼物盒 */
  giftBoxs?: Type[];
}

interface PreviewState {
  /** 礼盒弹窗显影 */
  showGiftDrawer: boolean;
}
class Preview extends React.Component<PreviewProps, PreviewState> {
  constructor(props: PreviewProps) {
    super(props);
    this.state = {
      showGiftDrawer: false,
    };
  }
  componentDidMount() {
    const { filmStyle } = this.props;
    if (filmStyle == "green") {
      loadHTMLImage(
        "https://sunzi7n.imaiyuan.com/spotify-code-film/card-green.png"
      );
    } else {
      loadHTMLImage(
        "https://sunzi7n.imaiyuan.com/spotify-code-film/card-yellow.png"
      );
    }
  }

  // 显示礼盒弹窗
  handleReset = () => {
    const { giftBoxs } = this.props;
    if (giftBoxs && giftBoxs.length > 0) {
      this.setState({ showGiftDrawer: true });
    } else {
      this.handleConfirm();
    }
  };

  // 加车并初始化动画
  handleConfirm = (vipIncrement?: VipIncrement, giftBox?: Type) => {
    this.setState({ showGiftDrawer: false });
    const { onConfirm } = this.props;
    onConfirm(vipIncrement, giftBox);
  };

  // 关闭礼盒弹窗
  handleClose = () => {
    this.setState({ showGiftDrawer: false });
  };

  render() {
    const {
      onClose,
      addPrice,
      renderContent,
      handleCloseCart,
      reStart,
      onCustom,
      filmStyle,
      uploadError,
      percent,
      selectPage,
      currencySymbol,
      showSpotify,
      shop,
      giftBoxs,
    } = this.props;
    const { showGiftDrawer } = this.state;
    const renderFilmEnd = () => {
      switch (filmStyle) {
        case "green":
          return (
            <img src={require(`@/assets/spotify-code-film/end-green.png`)} />
          );
        default:
          return (
            <img src={require(`@/assets/spotify-code-film/eng-right.png`)} />
          );
      }
    };
    return (
      <>
        <div className={styles.previewMain}>
          {!selectPage && (
            <div className={styles.previewTop}>
              <div className={styles.left} onClick={() => handleCloseCart()}>
                <Icon type="icon-left" size={25} color="#fff" />
              </div>
            </div>
          )}
          <div className={styles.previewContent}>
            {selectPage ? (
              <div className={styles.content}>
                <div className={styles.card}>
                  <div
                    className={classnames(styles.selectPage, {
                      [styles.bgGreen]: filmStyle == "green",
                    })}
                  >
                    <div className={styles.previewTop}>
                      <div className={styles.left} onClick={onClose}>
                        <Icon type="icon-left" size={30} color="#fff" />
                      </div>
                    </div>
                    <div className={styles.selectText}>
                      {i18n.format(
                        "modules.spotify.code.film.add.spotify.code"
                      ) + "?"}
                    </div>

                    <div className={styles.selectMain}>
                      <div className={styles.cdImg}>
                        {filmStyle == "green" ? (
                          <ImageLoad
                            source={
                              "https://sunzi7n.imaiyuan.com/spotify-code-film/card-green.png"
                            }
                          />
                        ) : (
                          <ImageLoad
                            source={
                              "https://sunzi7n.imaiyuan.com/spotify-code-film/card-yellow.png"
                            }
                          />
                        )}
                        <div className={styles.film}>
                          <div className={styles.shadow}>
                            <img
                              src={require(`@/assets/spotify-code-film/shadow-black.png`)}
                            />
                          </div>
                          <div className={styles.spotifyFilmStart}>
                            <img
                              src={require("@/assets/spotify-code-film/code-start.png")}
                            />
                          </div>
                          <div className={styles.spotifyFilmEnd}>
                            {renderFilmEnd()}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.selectBottom}>
                      <div
                        className={classnames(styles.customButton, {
                          [styles.shadowGreen]: filmStyle == "green",
                        })}
                        onClick={() => onCustom()}
                      >
                        <div
                          className={classnames(styles.addPrice, {
                            [styles.colorGreen]: filmStyle == "green",
                          })}
                        >
                          {"+" + priceFormat(currencySymbol!, addPrice)}
                        </div>
                        <div className={styles.addSpotify}>
                          {" "}
                          {i18n.format(
                            "modules.spotify.code.film.add.spotify.code"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.filmComplete}>
                  <div className={styles.filmBox}>
                    <div className={styles.shadowImg}>
                      <img
                        src={require(`@/assets/spotify-code-film/shadow-black.png`)}
                      />
                    </div>
                    <div className={styles.shadow}></div>
                    <div className={styles.filmStart}>
                      <img
                        src={require("@/assets/spotify-code-film/film-start.png")}
                      />
                    </div>
                    <div className={styles.filmEnd}>{renderFilmEnd()}</div>
                  </div>
                </div>
                <div
                  className={styles.confirmButton}
                  onClick={this.handleReset}
                >
                  <div className={styles.buttonItem}>
                    <div className={styles.buttonText}>
                      {/* {i18n.format("modules.spotify.code.film.add.to.cart")} */}
                      No thanks
                    </div>
                    <div className={styles.iconCart}>
                      <Icon type="icon-cart" size={22} color="#fff" />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // 普通加车页面
              <div className={classnames(styles.cardContent)}>
                {renderContent}
                <div
                  className={classnames(styles.cardLoading, {
                    [styles.cardLoadingGreen]: filmStyle == "green",
                  })}
                >
                  <NumLoading
                    showSpotify={showSpotify}
                    reStart={reStart}
                    percent={percent}
                  />
                </div>
                {!reStart && (
                  <div className={styles.reset}>
                    <div className={styles.resetWrapper}></div>
                    <div className={styles.resetBox} onClick={this.handleReset}>
                      <div className={styles.icon}>
                        <Icon type="reset" size={25} color="#F56C6C" />
                      </div>
                      <div className={styles.error}>Network Error!</div>
                      <div className={styles.again}>Try again</div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* 礼盒弹窗 */}
        {showGiftDrawer && giftBoxs && (
          <Wrapper>
            <GiftDrawer
              shop={shop!}
              giftBoxs={giftBoxs}
              mask
              currencySymbol={shop!.currencySymbol}
              onClose={this.handleClose}
              onConfirm={this.handleConfirm}
            />
          </Wrapper>
        )}
      </>
    );
  }
}

export default Preview;
